import React from "react";
import ReactDOM from "react-dom/client"; // <-- notice "client"
import { Amplify } from "aws-amplify";
import App from "./App";
import { PersistGate } from "redux-persist/integration/react";

import { store, persister } from "./redux/store";
import { Provider } from "react-redux";
import awsExports from "./config/aws-exports";

import { QueryClient, QueryClientProvider } from "react-query";
import 'tippy.js/dist/tippy.css';              // core styles
import 'tippy.js/themes/light.css';            // theme
import 'tippy.js/animations/shift-away-subtle.css'; // animation

Amplify.configure(awsExports);

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persister}>
          <App />
        </PersistGate>
      </Provider>
    </QueryClientProvider>
  </React.StrictMode>
);
